const request = {
    invalid_input: 'Input is invalid. {{details}}',
    general: 'Request error occurred.',
    range_not_satisfiable: 'Range not satisfiable.',
    too_many_requests: 'Too many requests.',
};
export default Object.freeze(request);
